import Vue from 'vue'
import Router from 'vue-router'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import AdminSeriesDetail from '@/views/admin/series/Details.vue'
import AdminSeriesList from '@/views/admin/series/List.vue'
import NotificationDetails from '@/views/member/inbox/Details.vue'
import authenticate from '@/middleware/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ '../views/Layout.vue'),
      children: [
        { name: 'series', path: 'series', component: AdminDashboard },
        { path: 'series/:id', component: AdminSeriesDetail, props: true },
        { path: 'series/:id/templates', component: AdminSeriesDetail, props: true },
        { path: 'series/:id/members', component: AdminSeriesDetail, props: true },
        { path: ':tab', component: AdminDashboard }
      ]
    },
    {
      path: '/member',
      name: 'member',
      component: () => import(/* webpackChunkName: "member" */ '../views/Layout.vue'),
      children: [
        { name: 'inbox', path: 'inbox', component: () => import(/* webpackChunkName: "member_dashboard" */ '../views/member/Dashboard.vue') },
        { path: 'inbox/:id', component: NotificationDetails, props: true },
        { path: ':tab', component: () => import(/* webpackChunkName: "member_dashboard" */ '../views/member/Dashboard.vue')}
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(authenticate)

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (err) {
      // If there really is an error, throw it
      // Should probably be more sophisticated based on the type of err
      return Promise.reject(err);
    }
    // Otherwise resolve to false to indicate the original push call didn't go to its original
    // destination.
    // TODO: return the final route instead of false?
    return Promise.resolve(false);
  });
};

export default router
